/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".load-more-button[_ngcontent-%COMP%]{height:40px;width:100px}"];
export { styles as styles };
